export default "__VITE_ASSET__BXtlQkx4__"